import { useQuery } from "@tanstack/react-query"
import { apiClientV2 } from "../../../services/api/apiClient"
import type { SupplierDashboardStats } from "./types"

const zero = { count: 0, total: 0 }

// No regulation rows until the dashboard loads: the rows are the org's own set
// (TUR-1734), so a fallback cannot guess them.
const EMPTY_FRAMEWORKS: SupplierDashboardStats["frameworks"] = []

export const EMPTY_DASHBOARD_STATS: SupplierDashboardStats = {
  articles: { ...zero },
  suppliers: { ...zero },
  statusBuckets: {
    inReview: { ...zero },
    awaiting: { ...zero },
    outdated: { ...zero },
    neverAsked: { ...zero, noContact: 0, bounced: 0 },
  },
  frameworks: EMPTY_FRAMEWORKS,
  replyQuality: { committed: 0, extractionEmpty: 0, conflicts: 0 },
  handedBack: { escalated: 0, undeliverable: 0, complained: 0 },
  inReviewTop: [],
  outstandingTop: [],
  outstandingTotal: 0,
}

async function getSupplierDashboard(): Promise<SupplierDashboardStats> {
  // No .catch() here — a network/server error must reject so React Query
  // surfaces isError and retries, instead of silently rendering an empty
  // org (see F9). The caller (DashboardPage) supplies EMPTY_DASHBOARD_STATS
  // as display fallback while showing an error banner.
  return apiClientV2
    .get("/material-compliance/supplier-studio/dashboard")
    .then((r) => ({
      ...EMPTY_DASHBOARD_STATS,
      ...(r.data as Partial<SupplierDashboardStats>),
    }))
}

export function useSupplierDashboard() {
  return useQuery({
    queryKey: ["mc", "supplier-dashboard"],
    queryFn: getSupplierDashboard,
  })
}
